import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { FC } from 'react';

interface ROWarningModalProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const ROWarningModal: FC<ROWarningModalProps> = ({ isOpen, setIsOpen }) => {
  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)} fullWidth>
      <Box display="flex" flexDirection="column" px={8} my={4}>
        <DialogContent>
          <Box display="flex" justifyContent="center" mb={4}>
            <ErrorOutlineIcon color="warning" sx={{ fontSize: 100 }} />
          </Box>
          <Typography>
            This RO was not found in our system. On ticket creation, a fake RO will be created and
            associated with this ticket.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ alignSelf: 'center' }}>
          <Button variant="contained" color="primary" onClick={() => setIsOpen(false)} size="large">
            Ok
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default ROWarningModal;
